import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Table, Card, Loader, Icon, Popup, Modal, Dropdown} from 'semantic-ui-react';
import {pageSizes} from '../../../common/constants/lists';
import {
  headerCellTitlesOfData,
  headerCellTitlesOfControl,
} from '../static/commonStructures';
import TablePaginator from '../../../common/components/tablePaginator';


class SpecialPartsListTable extends Component {
  componentDidUpdate(prevProps) {
    const {pageNumber, pageSize, specialPartList} = this.props;

    if (specialPartList.length === 0) {
      return;
    }

    if (
      pageNumber !== prevProps.pageNumber ||
      pageSize !== prevProps.pageSize
    ) {
      this.props.onUpdate();
    }
  }

  renderTableHeader() {
    return (
      <Table.Header>
        <Table.Row>{this.renderTableHeaderCells()}</Table.Row>
      </Table.Header>
    );
  }

  renderTableHeaderCells() {
    const fieldsToDisplay = headerCellTitlesOfData.concat(
      headerCellTitlesOfControl
    );

    return fieldsToDisplay.map((header) => {
      return (
        <Table.HeaderCell key={`header${header.serializedName}`}>
          {header.name}
        </Table.HeaderCell>
      );
    });
  }

  renderTableBody() {
    const {loadingSpecialPartList} = this.props;

    return (
      <Table.Body>
        {loadingSpecialPartList ? this.renderLoader() : this.renderValues()}
      </Table.Body>
    );
  }

  renderLoader() {
    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Loader active inline='centered' />
        </Table.Cell>
      </Table.Row>
    );
  }

  renderValues() {
    const {specialPartList} = this.props;

    if (!specialPartList) {
      return null;
    }

    if (!specialPartList.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan='100%'>No hay datos disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return specialPartList.map((row, rowIndex) => {
      return (
        <Table.Row key={`row${rowIndex}`}>
          {this.renderDataInCells(row, rowIndex)}
          {this.renderActionsInCells(row)}
        </Table.Row>
      );
    });
  }

  renderDataInCells(row, rowIndex) {
    return headerCellTitlesOfData.map((title, columnIndex) => {
      return (
        <Table.Cell textAlign='center' key={`element${rowIndex}${columnIndex}`}>
          {row[title.serializedName]}
        </Table.Cell>
      );
    });
  }

  renderActionsInCells(row) {
    const {handleConfirmDeleteClick} = this.props;
    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link
              to={{
                'pathname': `/partes-especiales/editar/${row.partNo}`,
              }}
            >
              <Icon
                name='write'
                color='blue'
                size='large'
              />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />

        <Modal
          size='mini'
          trigger={
            <span className='link'>
              <Popup
                trigger={
                  <span>
                    <Icon link name='close' color='red' size='large' />
                  </span>
                }
                content='Eliminar'
                position='top center'
                inverted
              />
            </span>
          }
          header='¿Está SEGURO de eliminar el item seleccionado? Esta acción es PERMANENTE'
          actions={[
            {'key': 'cancel', 'content': 'Cancelar'},
            {
              'key': 'done',
              'content': 'Confirmar',
              'positive': true,
              'onClick': handleConfirmDeleteClick.bind(this, row),
              'primary': true,
            },
          ]}
        />
      </Table.Cell>
    );
  }

  renderPagination() {
    const {
      pageNumber,
      pageSize,
      totalItems,
      specialPartList,
      handlePageSizeChange,
      handlePageClick,
    } = this.props;
    if (totalItems <= pageSize || !specialPartList.length) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={handlePageSizeChange}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={handlePageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table>
          {this.renderTableHeader()}
          {this.renderTableBody()}
          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

export default SpecialPartsListTable;
